import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {}

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      title: 't(New Suspension)',
      method: 'POST',
      action: '/api/admin/truevail/admin/deliverability/suspensions',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Team)', 
              name: 'team_id', 
              type: 'lookup',
              endpoint: '/api/admin/truevail/admin/teams',
              filter: {
                status: {
                  $eq: 'active'
                }
              },
              valueKey: 'id',
              textKey: 'title',
              required: true 
            },
            { 
              label: 't(Reason)', 
              name: 'reason', 
              type: 'radiogroup', 
              options: [
                { value: 'verifications', text: 't(You added over the allowed percentage of contacts with invalid email address)' },
                { value: 'hard_bounces', text: 't(You sent too many emails which hard bounced and could not be delivered)' },
                { value: 'soft_bounces', text: 't(You sent too many emails which soft bounced and could not be delivered)' },
                { value: 'low_open_rates', text: 't(You sent an email with a zero percent open rate)' },
                { value: 'complaints', text: 't(You sent too many emails which were reported by recipients as SPAM)' }
              ],
              defaultValue: 'verifications',
              required: true 
            },
            { 
              label: 't(Custom Message)', 
              name: 'message', 
              type: 'htmlfield',
              rows: 3
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(holiday) {
    this.context.modal.close()
  }

}

export default New
